import { render, staticRenderFns } from "./SQuesThirteen.vue?vue&type=template&id=dc9b474e&scoped=true&"
import script from "./SQuesThirteen.vue?vue&type=script&lang=js&"
export * from "./SQuesThirteen.vue?vue&type=script&lang=js&"
import style0 from "./SQuesThirteen.vue?vue&type=style&index=0&id=dc9b474e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc9b474e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCardText})
